import { Component, h, Element, Prop, State } from '@stencil/core';
import YouTubePlayer from 'youtube-player';

@Component({
  tag: 'wdf-video',
  shadow: false,
})

export class Video {
  @Prop() videoid: string;
  @Prop() thumbid: string;
  @State() showImage: boolean = true;

  @Element() el: HTMLElement;

  @State() MdThumbnail: any = null;
  @State() containerId: string = null;


  async componentWillLoad() {
    // try {
    //   await this.getThumbImage();
    // } catch (error) {
    //   console.error('An error occurred while fetching data:', error);
    // }
    this.getThumbImage();
  }

  playVideo = () => {
    let playerWidth = this.el.offsetWidth;
    let player = YouTubePlayer(this.containerId, {videoId: this.videoid, width: `${playerWidth}`,});
    player.playVideo();
  }

  getThumbImage = () => {
    this.containerId = `video-container-${this.videoid}`
    const thumbidJson = JSON.parse(this.thumbid);
    const crops = thumbidJson.crops;
    if (crops){
      let targetAlias = "large";
      let mdcrop = crops.find(crop => crop.alias === targetAlias || crop.alias === 'lage')
      if (mdcrop.coordinates != null){
        this.MdThumbnail = `${thumbidJson.src}?cc=${mdcrop.coordinates.x1},${mdcrop.coordinates.y1},${mdcrop.coordinates.x2},${mdcrop.coordinates.y2}&format=webp&quality=90&width=${mdcrop.width}&height=${mdcrop.height}`;
      }else{
        this.MdThumbnail = `${thumbidJson.src}?format=webp&quality=90&width=${mdcrop.width}&height=${mdcrop.height}`;
      }
    }
    else{
      this.MdThumbnail = `${thumbidJson.src}?format=webp&quality=90`;
    }
  }

  render() {
    return (
      this.showImage ? (
          <div id={this.containerId} class="aspect-video relative">
            <img src={this.MdThumbnail}/>
            <svg class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-20 h-20 md:w-122 md:h-122 text-red cursor-pointer" onClick={this.playVideo}>
              <use xlinkHref="/assets/spritemap.svg#play" />
            </svg>
          </div>
        ):(
          <div id={this.containerId} class="aspect-video"></div>
        )
    )
  }
}
